
import { FormattedMessage } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';

import { VACATIONS_PAGE, getAccountUsernameFromPath } from '@share/utils';
import { BlueButton } from '@share/components';
import { Routes } from '@share/constants';

import NotAvailable from '@assets/images/availability-status.png';

import './style.scss';
import { isEmpty } from 'lodash';

interface IProps {
  isFromCondo?: boolean;
  isVacationRentals?: boolean;
  sessionId: string;
}

export function AvailabilityError(props: IProps) {
  const { isFromCondo = false, isVacationRentals, sessionId } = props;

  const history = useHistory();

  const accountName = getAccountUsernameFromPath(history);

  const url = isFromCondo
    ? `/${accountName}${Routes.CondoSearch}${location.search}`
    : isVacationRentals ? 
      `/${accountName}${Routes.Search}/${VACATIONS_PAGE}${location.search}` :
      `/${accountName}${Routes.Search}${location.search}`;

  return (
    <div className="availability-error">
      <img src={NotAvailable} alt="" />
      <p className="availability-error__title secondary-font">
        <FormattedMessage id="unit.is.no.available" />
      </p>

      <p className="availability-error__description">
        <FormattedMessage id={isFromCondo ? 'condo.unit.selected.no.longer.available' : 'unit.selected.no.longer.available'} />

        {!isEmpty(sessionId) && (
          <span style={{ marginLeft: '10px' }}>
            <FormattedMessage id="session.id" values={{ sessionId }} />
          </span>)}
      </p>

      
      <div className="availability-error__btn-wrapper">
        <Link to={url}>
          <BlueButton>
            <FormattedMessage id={isFromCondo ? 'search.condos' : 'search.hotel'} />
          </BlueButton>
        </Link>
      </div>
    </div>
  );
}
